import { type FC, type PropsWithChildren } from 'react';
import { Form } from '@adv-frontend/form-kit';
import { changeVariantPriceTooltipForm } from '../../model';
import { type ChangedVariantPrice } from '../../types';

type ChangeVariantPriceFormProps = PropsWithChildren<{
    variant: ChangedVariantPrice;
    formId: string;
}>;

export const ChangeVariantPriceForm: FC<ChangeVariantPriceFormProps> = ({ children, variant, formId }) => (
    <Form
        form={changeVariantPriceTooltipForm}
        initialValue={{
            price: String(variant.price),
            finalPrice: String(variant.final_price),
            minimalPrice: String(variant.minimal_price),
            promotionPrice: String(variant.promotion_price),
            manualDiscountPrice: String(variant.manual_discount_price),
        }}
        context={{
            id: variant.id,
            discount: variant.discount,
        }}
        id={formId}
    >
        {children}
    </Form>
);
